import api from './api';
import { 
  buscarDadosPorId, 
  salvarDados, 
  buscarDados, 
  excluirDadosPorId, 
  excluirDadosCompleto, 
  API_BASE_URL
} from './indexedDb.js';
import { Toast, isNative } from '../context/MenuProvider';

async function registrarNativo() {
    console.log('[Híbrido] Iniciando modo Nativo');

    window.api = api;
    window.buscarDadosPorId = buscarDadosPorId;
    window.salvarDados = salvarDados;
    window.buscarDados = buscarDados;
    window.excluirDadosPorId = excluirDadosPorId;
    window.excluirDadosCompleto = excluirDadosCompleto;
    window.API_BASE_URL = API_BASE_URL;

    const scripts = [
        '/native-env.js',
        '/native-sync-bridge.js',
        '/native-push.js',
        '/sync.js',
        '/service-worker.js'
      ];

    for (const src of scripts) {
        await new Promise((resolve) => {
          const s = document.createElement('script');
          s.src = src;
          s.async = false;
          s.onload = resolve;
          document.head.appendChild(s);
        });
      }

    if (window.registerNativePush) {
        window.registerNativePush(api, API_BASE_URL);
    }

    if (window.dispatchNativeMessage) {
        setTimeout(() => window.dispatchNativeMessage('app-abriu'), 1000);
    }

    console.log('[Native] Fluxo híbrido carregado com sucesso.');

    window.addEventListener('sw-response', async (e) => {
      const data = e.detail;
      
      if (data === 'titulo') {
        const app = await buscarDadosPorId("local_registros", "app");
        if (app?.name) document.title = app.name;
      }
      
      if (data === 'iniciar_in') {
        Toast.fire({ icon: 'success', title: 'Sincronização iniciada' });
      } else if (data === 'iniciar_out') {
        Toast.fire({ icon: 'success', title: 'Sincronização finalizada' });
      } else if (data === 'iniciar_erro') {
        Toast.fire({ icon: 'error', title: 'Falha na sincronização' });
      }
    });
}

function registerServiceWorker() {
  if (isNative) {
    registrarNativo();
  }

  else if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js')
      .then(async (registration) => {
        console.log('Service Worker registrado com sucesso:', registration);

        if ('SyncManager' in window) {
          try {
            await registration.sync.register('sincronizar-dados');
            console.log('Background Sync registrado com sucesso');
          } catch (error) {
            console.error('Erro ao registrar Background Sync:', error);
          }
        }

        registration.update();
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
              window.location.reload();
            }
          };
        };

        navigator.serviceWorker.ready.then(() => {
          if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage('app-abriu');
          } else {
            window.location.reload();
          }
        });

        if ('PushManager' in window) {
          await checkNotificationPermission(registration);
        }

        listenToServiceWorkerMessages();
        
        window.addEventListener('online', () => {
          if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage('voltou-conexao');
          }
        });
      })
      .catch((error) => {
        console.error('Falha ao registrar o Service Worker:', error);
      });
  } 
  
  else {
    console.error('Service Worker não disponível neste navegador.');
  }
}

async function checkNotificationPermission(registration) {
  if (Notification.permission === 'granted') {
    await handlePushSubscription(registration);
  } else if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      await handlePushSubscription(registration);
    }
  }
}

async function handlePushSubscription(registration) {
  try {
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await sendSubscriptionToServer(subscription);
    } else {
      const newSubscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: 'BAvBHS6_NiRFtkNXetGzifhyKdwo5GjcGHwHSeDeEJ9s8e4hfnSXuFBqkIoKmFHxa4VE4h_tVHA0To2bYTqIbpM'
      });
      await sendSubscriptionToServer(newSubscription);
    }
  } catch (error) {
    console.error('Erro ao gerenciar inscrição:', error);
  }
}

async function sendSubscriptionToServer(subscription) {
  try {
    const subData = {
      endpoint: subscription.endpoint,
      p256dh: btoa(
        String.fromCharCode(...new Uint8Array(subscription.getKey('p256dh')))
      ),
      auth: btoa(
        String.fromCharCode(...new Uint8Array(subscription.getKey('auth')))
      )
    };
    //alert(JSON.stringify(subData))
    await api.post(`${API_BASE_URL}/core/push/`, subData, { is_auth: true });
  } catch (error) {
    //alert(`Erro Subs: ${JSON.stringify(error?.response || error)}`)
  }
}

function listenToServiceWorkerMessages() {
  navigator.serviceWorker.addEventListener('message', async(event) => {
    if(event.data===`titulo`){
      const app = await buscarDadosPorId("local_registros", "app");
      document.title = app?.name||``;
    }
    
    if(event.data===`iniciar_in`){
        Toast.fire({ icon: 'success', title: 'Sincronização iniciada' });
    }
    else if(event.data===`iniciar_out`){
        Toast.fire({ icon: 'success', title: 'Sincronização finalizada' });
    }
    else if(event.data===`iniciar_erro`){
        Toast.fire({ icon: 'error', title: 'Falha na sincronização' });
    }
  });
}

function requestNotificationPermission() {
  Notification.requestPermission();
}

export default registerServiceWorker;
export { requestNotificationPermission };
